<template>
  <div class="detailPage">
    <div class="headerShow">
      <common-header :menu-list="menuList" :menuActive="menuActive" @menuClick="menuClick" @logoClick="logoClick"></common-header>
    </div>
    <div class="pageMain">
      <div class="mainTitle">
        {{titleShow}}
      </div>
      <div class="mainContent">
        <div class="backIndex" @click="backIndex">
          {{'<'}}  Back
        </div>
        <div class="contentShow" v-html="contentShow">

        </div>
      </div>
    </div>
    <div class="pageBottom">
      <page-bottom-taiwan v-if="$i18n.locale === 'tw'"></page-bottom-taiwan>
      <page-bottom v-else :rules="bottomRules" :icon-link="bottomIconLink"
      :language="pageLanguage"></page-bottom>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import commonHeader from "@/components/CommonHeader/index.vue";
import pageBottom from "@/components/PageBottom/index.vue";
import { getDetailById }  from '@/api/index'
import PageBottomTaiwan from "@/components/PageBottomTaiwan/index.vue";
export default {
  name: 'detailPage',
  components: {PageBottomTaiwan, commonHeader,pageBottom},
  data() {
    return {
      menuList: [],
      menuActive: '0',
      titleShow: '',
      contentShow: '',
      bottomRules: [],
      bottomIconLink: [],
      pageLanguage: ''
    }
  },
  computed: {
    title() {
      return this.$t('title');
    }
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: '%s'
    }
  },
  created() {
    this.setI18nInfos()
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    ...mapMutations(['SET_INDEX_PAGE']),
    // 赋值i18n数据
    setI18nInfos() {
      const currentLocale = this.$i18n.locale; // 获取当前语言
      const messages = this.$i18n.getLocaleMessage(currentLocale); // 获取当前语言的所有消息
      this.pageLanguage = currentLocale
      this.menuList = messages.menu
      this.bottomRules = messages.pageBottom.ruleList
      this.bottomIconLink = messages.pageBottom.iconAndLink
    },
    getDetailInfo(){
      let id = this.$route.query && this.$route.query.id
      getDetailById(id).then(res => {
        if (res.data.code === 0){
          let data = res.data.data
          this.titleShow = data.title
          this.contentShow = data.richText
        }else {
          console.log('error');
          console.log(res);
        }
      })
    },
    menuClick(row) {
      this.SET_INDEX_PAGE(row.id)
      const currentLang = this.$i18n.locale; // 获取当前语言
      this.$router.push(`/${currentLang}`)
    },
    backIndex() {
      const currentLang = this.$i18n.locale; // 获取当前语言
      // this.SET_INDEX_PAGE('news')
      this.$router.push(`/${currentLang}`)
    },
    logoClick() {
      const currentLang = this.$i18n.locale; // 获取当前语言
      this.$router.push(`/${currentLang}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.detailPage{
  height: 100%;
  width: 100%;
  padding-top: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .headerShow{
    position: fixed;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 62px;
    background: #152c58;
  }
  .pageMain{
    flex: 1 0 auto;
    //display: flex;
    //flex-direction: column;
    .mainTitle{
      //height: 237px;
      display: flex;
      align-items: center;
      padding: 128px 12%;
      font-size: 42px;
      text-align: left;
      font-weight: bold;
      color: white;
      background-image: url("@/assets/imgs/detailBg.png");
    }
    .mainContent{
      flex-grow: 1;
      padding: 0 12%;
      text-align: left;
      .backIndex{
        margin-top: 39px;
        margin-bottom: 36px;
        color: #5D5D5D;
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
      }
    }
  }
  .pageBottom{

  }
}
</style>
